import { fleetMode } from '../../constants/dossier/common/documentEditionModal'
import { documentEntityType as documentEntityTypeConstants } from '../../constants/dossier/common/documentEntityType'
import { documentTypeUse as documentTypeUseConstants, dossierSubTypes } from '../../constants/backendIds'
import { dossierTypes as dossierTypesConstant, dossierTypesId } from '../../constants/dossier/common/dossierTypes'
import { dossierStagesBySubtype } from '../../constants/dossier/common/dossierStages'
import { replaceableFields } from '../../constants/dossier/common/replaceableFields'
import { saleFinalDocStages, purchaseFinalDocStages } from '../../constants/dossier/sale/stages'
import { approvalRoleCode, approvalType } from '../../constants/dossier/sale/approvalRoleCode'

export function validateDistinctStage (dossiers) {
  return dossiers.map(x => x.stageId).filter((x, i, a) => a.indexOf(x) === i).length > 1
}

function validateDistinctUo (dossiers) {
  return dossiers.map(x => x.organizedUnitId).filter((x, i, a) => a.indexOf(x) === i).length > 1
}

export function openOrCloseServiceAddModal (value, props, setState) {
  props.actions.fetchDossierSubTypes(null, dossierTypesId.sales)
  setState({ showServiceModal: value })
}

function areSaleLastStage (dossiers) {
  return dossiers.map(x => x.stageId).filter((x, i, a) => a.indexOf(x) === i).every((x) => saleFinalDocStages.includes(x))
}

function arePurchaseLastStage (dossiers) {
  return dossiers.map(x => x.stageId).filter((x, i, a) => a.indexOf(x) === i).every((x) => purchaseFinalDocStages.includes(x))
}

function haveDossiers (dossiers) {
  return dossiers.length > 0
}

export function setChargeData (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    var organizedUnitId = props.fleetData.organizedUnitId
    if (dossiers && dossiers.length > 0) {
      organizedUnitId = dossiers[0].organizedUnitId
    }
    props.actions.openDocumentEditionModalFleet(
      fleetMode.INCORPORATE_CHARGE,
      null,
      documentTypeUseConstants.charge,
      documentEntityTypeConstants.DOSSIER,
      dossiers.map(x => { return x.dossierId }),
      null,
      null,
      null,
      organizedUnitId,
      null,
      null,
      true,
      dossierTypesConstant.sales,
      null,
      null,
      null,
      null,
      null,
      true,
      false,
      null,
      null,
      null,
      props.fleetData.fleet.fleetId
    )
  }
}

export function setSaleData (dossiers, props, setState) {
  if (validateDistinctStage(dossiers) || validateDistinctUo(dossiers)) {
    props.actions.openModal('notDistinctUoAndStage')
  } else {
    let fleet = props.fleetData.fleet
    fleet.stageId = dossierStagesBySubtype.saleVn.provisional
    if (dossiers && dossiers.length > 0) {
      fleet.stageId = dossiers[0].stageId
      fleet.organizedUnitIdDossier = dossiers[0].organizedUnitId
    }
    props.actions.openDataSalesFleetModal(fleet, dossiers)
  }
}

export function setPurchaseData (dossiers, props, setState) {
  if (validateDistinctStage(dossiers) || validateDistinctUo(dossiers)) {
    props.actions.openModal('notDistinctUoAndStage')
  } else {
    let fleet = props.fleetData.fleet
    fleet.stageId = dossierStagesBySubtype.saleVn.provisional
    if (dossiers && dossiers.length > 0) {
      fleet.stageId = dossiers[0].stageId
      fleet.organizedUnitIdDossier = dossiers[0].organizedUnitId
      fleet.dossierSubTypeIdAux = dossiers[0].dossierSubTypeId
    }
    props.actions.openDataPurchasesFleetModal(fleet, dossiers)
  }
}

export function setOperateContactData (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    let fleet = props.fleetData.fleet
    fleet.stageId = dossierStagesBySubtype.saleVn.provisional
    if (dossiers && dossiers.length > 0) {
      fleet.stageId = dossiers[0].stageId
      fleet.organizedUnitIdDossier = dossiers[0].organizedUnitId
    }
    props.actions.openDataContactFleetModal(fleet, dossiers)
  }
}

export function setDeliveryData (dossiers, props, setState, someDossierHasDelivery = false) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else if (!haveDossiers(dossiers)) {
    props.actions.openModal('noDossiersOnFleet')
  } else {
    let fleet = props.fleetData.fleet
    fleet.stageId = dossierStagesBySubtype.saleVn.provisional
    if (dossiers && dossiers.length > 0) {
      fleet.stageId = dossiers[0].stageId
      fleet.organizedUnitIdDossier = dossiers[0].organizedUnitId
    }
    props.actions.openDataDeliveryFleetModal(fleet, dossiers, someDossierHasDelivery)
  }
}

export function setOperatePaperWorkData (dossiers, props, setState) {
  if (validateDistinctStage(dossiers) || validateDistinctUo(dossiers)) {
    props.actions.openModal('notDistinctUoAndStage')
  } else {
    let fleet = props.fleetData.fleet
    fleet.stageId = dossierStagesBySubtype.paperWork.init
    if (dossiers && dossiers.length > 0) {
      fleet.stageId = dossiers[0].stageId
      fleet.organizedUnitIdDossier = dossiers[0].organizedUnitId
    }
    props.actions.openDataPaperWorkFleetModal(fleet, dossiers)
  }
}

export function setFinancingData (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.fetchFinancingCompaniesBy(props.fleetData.fleet.organizedUnitId)
    let fleet = props.fleetData.fleet
    fleet.stageId = dossierStagesBySubtype.saleVn.provisional
    if (dossiers && dossiers.length > 0) {
      fleet.stageId = dossiers[0].stageId
      fleet.organizedUnitIdDossier = dossiers[0].organizedUnitId
    }
    props.actions.openDataFinancingFleetModal(fleet, dossiers)
  }
}

export function setOperateActionSendToApprovalProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToApprovalProcessConfirm', () => { props.actions.setOperateActionSendToApprovalProcess(dossiers, props.fleetData.fleet.fleetId, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionApproveProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionApproveProcessConfirm', () => { props.actions.setOperateActionApproveProcess(dossiers, props.fleetData.fleet.fleetId, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionRejectProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionRejectProcessConfirm', () => setState({ showRejectCommentModal: true }), null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionApprovePaperworkProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionApprovePaperworkProcessConfirm', () => { props.actions.setOperateActionApprovePaperworkProcess(dossiers, props.fleetData.fleet.fleetId, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionSendToAgencyProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToAgencyProcessConfirm', () => { props.actions.setOperateActionSendToAgencyProcess(dossiers, props.fleetData.fleet.fleetId) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionPrintDeliveryNoteProcess (dossiers, props, setState, mustIncorporate = false) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionPrintDeliveryNoteProcessConfirm', () => { props.actions.setOperateActionPrintDeliveryNoteProcess(dossiers, props.fleetData.fleet.fleetId, null, mustIncorporate) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionDeleteProcess (dossiers, props, setState) {
  props.actions.openModal('setOperateActionDeleteProcessConfirm', () => { setState({ showCancelReasonModal: true }) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
}

export function setOperateActionStoreProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else if (!areSaleLastStage(dossiers)) {
    props.actions.openModal('saleDossiersNotInLastStage')
  } else {
    props.actions.openModal('setOperateActionStoreProcessConfirm', () => { props.actions.setOperateActionStoreProcess(dossiers, props.fleetData.fleet.fleetId, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionSendToApprovalPurchaseProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToApprovalPurchaseProcessConfirm', () => { props.actions.setOperateActionSendToApprovalPurchaseProcess(dossiers, props.fleetData.fleet.fleetId, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionApprovePurchaseProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionApprovePurchaseProcessConfirm', () => { props.actions.setOperateActionApprovePurchaseProcess(dossiers, props.fleetData.fleet.fleetId, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionRejectPurchaseProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionRejectPurchaseProcessConfirm', () => setState({ showRejectCommentModal: true }), null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionDeletePurchaseProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionDeletePurchaseProcessConfirm', () => { setState({ showCancelReasonModal: true }) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionStorePurchaseProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else if (!arePurchaseLastStage(dossiers)) {
    props.actions.openModal('saleDossiersNotInLastStage')
  } else {
    props.actions.openModal('setOperateActionStorePurchaseProcessConfirm', () => { props.actions.setOperateActionStorePurchaseProcess(dossiers, props.fleetData.fleet.fleetId, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionJvApproval (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToApprovalProcessConfirm', () => { props.actions.setApproveActionProcess(dossiers.map(x => x.dossierId).join('$'), 3, approvalRoleCode.SALES_MANAGER, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionAdministrationApproval (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToApprovalProcessConfirm', () => { props.actions.setApproveActionProcess(dossiers.map(x => x.dossierId).join('$'), 3, approvalRoleCode.ADMINISTRATION, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionManagerApproval (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToApprovalProcessConfirm', () => { props.actions.setApproveActionProcess(dossiers.map(x => x.dossierId).join('$'), 3, approvalRoleCode.MANAGER, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setAuthorizeFinanceOperateFleet (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToApprovalProcessConfirm', () => { props.actions.setApproveActionProcess(dossiers.map(x => x.dossierId).join('$'), approvalType.ROLE_AUTHORIZE_FINANCE, approvalRoleCode.APPROVE_AUTHORIZE_FINANCE, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setAuthorizeManagementOperateFleet (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToApprovalProcessConfirm', () => { props.actions.setApproveActionProcess(dossiers.map(x => x.dossierId).join('$'), approvalType.ROLE_AUTHORIZE_MANAGEMENT, approvalRoleCode.APPROVE_AUTHORIZE_MANAGEMENT, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionFleetApproval (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToApprovalProcessConfirm', () => { props.actions.setApproveActionProcess(dossiers.map(x => x.dossierId).join('$'), 3, approvalRoleCode.FLEETS, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOperateActionAuthorizeManagementApproval (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToApprovalProcessConfirm', () => { props.actions.setApproveActionProcess(dossiers.map(x => x.dossierId).join('$'), 3, approvalRoleCode.FLEETS, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}

export function setOtherData (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else if (dossiers[0].dossierSubTypeId !== dossierSubTypes.sale_vo) {
    props.actions.openModal('notValidSubtypeSvo')
  } else {
    let fleet = props.fleetData.fleet
    fleet.stageId = dossierStagesBySubtype.saleVo.provisional
    fleet.isPurchase = false
    if (dossiers && dossiers.length > 0) {
      fleet.stageId = dossiers[0].stageId
      fleet.organizedUnitIdDossier = dossiers[0].organizedUnitId
    }
    props.actions.openDataOtherDataFleetModal(fleet, dossiers)
  }
}

export function setOtherDataPurchase (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else if (dossiers[0].dossierSubTypeId !== dossierSubTypes.purchase_vo) {
    props.actions.openModal('notValidSubtypePvo')
  } else {
    let fleet = props.fleetData.fleet
    fleet.stageId = dossierStagesBySubtype.purchaseVo.provisional
    fleet.isPurchase = true
    if (dossiers && dossiers.length > 0) {
      fleet.stageId = dossiers[0].stageId
      fleet.organizedUnitIdDossier = dossiers[0].organizedUnitId
    }
    props.actions.openDataOtherDataFleetModal(fleet, dossiers)
  }
}

export function createServiceData (dossiers, props, setState) {
  if (validateDistinctStage(dossiers) || validateDistinctUo(dossiers)) {
    props.actions.openModal('notDistinctUoAndStage')
  } else {
    new Promise((resolve) => {
      props.actions.fetchGetCanCreateOperateServices(dossiers[0].organizedUnitId, props.fleetData.fleet.dossierSubType, resolve)
    }).then((response) => {
      if (response && response.length > 0) {
        setState({ subTypesAllowedToCreate: response, dossierList: dossiers })
        openOrCloseServiceAddModal(true, props, setState)
      } else {
        props.actions.openModal('notServiceExpedientesAvailable')
      }
    })
  }
}

export function getDataPurchaseActions (dataPurchaseActions, dossierSubTypeId) {
  const excludedFunctions = ['setOtherDataPurchase']
  if (dossierSubTypeId === dossierSubTypes.purchase_vn) {
    return dataPurchaseActions.filter(x => !excludedFunctions.includes(x.function))
  }
  return dataPurchaseActions
}
export function getSaleOperateActions (operationActions, dossierSubTypeId) {
  const excludedFunctions = ['setOperateActionApproveNationalVoProcess', 'setOperateActionApproveExportControlProcess']
  if (dossierSubTypeId === dossierSubTypes.sale_vn) {
    return operationActions.filter(x => !excludedFunctions.includes(x.function))
  }
  return operationActions
}
export function setOperateActionApproveNationalVoProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToApprovalProcessConfirm', () => { props.actions.setApproveActionProcess(dossiers.map(x => x.dossierId).join('$'), approvalType.ROLE_APPROVE, approvalRoleCode.APPROVE_NATIONAL_VO, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}
export function setOperateActionApproveExportControlProcess (dossiers, props, setState) {
  if (validateDistinctStage(dossiers)) {
    props.actions.openModal('notDistinctStage')
  } else {
    props.actions.openModal('setOperateActionSendToApprovalProcessConfirm', () => { props.actions.setApproveActionProcess(dossiers.map(x => x.dossierId).join('$'), approvalType.ROLE_APPROVE, approvalRoleCode.APPROVE_EXPORT_CONTROL, null) }, null, null, null, [{ id: replaceableFields.numDossiers, value: dossiers.length }], null)
  }
}
